/* Action Types */
export const LOAD_BIDDER_BIDDING_ALL_FAIL = 'la/domain/bidderBiddingAll/LOAD_FAIL';
export const LOAD_BIDDER_BIDDING_ALL_REQUEST = 'la/domain/bidderBiddingAll/LOAD_REQUEST';
export const LOAD_BIDDER_BIDDING_ALL_SUCCESS = 'la/domain/bidderBiddingAll/LOAD_SUCCESS';
